/**
 * Página de resultado para exibir mensagens de sucesso ou erro após uma transação.
 * Esta página pode ser acessada após o processo para informar o usuário sobre o status da operação.
 */
import { useLocation, useNavigate } from 'react-router-dom';
import Botao from '../../componentes/Botao';



export default function Resultado() {

    
    const location = useLocation();
    const navigate = useNavigate();

    console.log("Conteúdo do State recebido em resultado:", location.state);
    /**
     * Objeto para mapear os ícones para exibir de acordo com o status 
     */
    const CONFIG_STATUS = {
            sucesso: {
                icone: 'check_circle',
                cor: 'var(--corFonteMensagemSucesso)',
                imagem: '/imagens/sucesso-viver.png' // Exemplo se usar imagem
            },
            erro: {
                icone: 'error',
                cor: 'var(--corFonteMensagemErro)',
                imagem: '/imagens/erro-viver.png'
            },
            aviso: {
                icone: 'warning',
                cor: 'var(--corFonteMensagemAviso)',
                imagem: '/imagens/aviso-viver.png'
            }

            
};

    // Pegamos os dados do state. Se não vier nada (acesso direto), usamos valores padrão.
    const { status, mensagem } = location.state || {status: 'erro', mensagem: 'Nenhuma informação disponível.'};
    
    // Busca a informação baseada no tipo recebido conforme o array da  const CONFIG_STATUS 
    const config = CONFIG_STATUS[status] 

    return (
        <div className='container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-body-tertiary'>
            <div className="col-12 col-md-8 col-lg-5 text-center p-5 shadow-sm rounded-4 bg-white">
                <div className='mb-1'>
                    {/* Aqui posso definir a imagem de feedback conforme o status */}
                    <span className="material-symbols-outlined" 
                        style={{ fontSize: '100px', color: config.cor }}>
                        {config.icone}
                    </span>
                </div>

                {/* Títulos com hierarquia visual clara */}
                <h1 className="h1 fw-bold mb-3" style={{ color: config.cor }}>{status}</h1>
                <p className="text-center mb-5 fs-1" style={{ color: config.cor }}>
                    {mensagem}
                </p>

                {/* Botão com largura controlada */}
                <div className="d-grid gap-2 col-8 mx-auto">

                    <Botao 
                        className="btn btn-outline-primary btn-lg fs-3" 
                        tipo="button" 
                        aoClicar={() => navigate('/')}
                        
                    >
                        Início
                    </Botao>
                    <Botao 
                        className="btn btn-outline-primary btn-lg fs-3" 
                        tipo="button" 
                        aoClicar={() => navigate(-1)}
                        
                    >
                        Página Anterior
                    </Botao>
                </div>   
            </div>     
        </div>
        
    )
}